export default "__VITE_PUBLIC_ASSET__0cd856b6__"